import type { LocationModel } from '@/entities/location';
import type { LocationWithData } from '../../../model/map-provider.interface';

export const MAP_DEFAULTS = {
  CENTER: [0, 0] as [number, number],
  ZOOM: 6,
  CIRCLE_MIN_RADIUS: 10,
  CIRCLE_MAX_RADIUS: 50,
  CIRCLE_SCALE_FACTOR: 5
} as const;

export function calculateMapCenter(
  locations: (LocationModel | LocationWithData)[],
  configCenter?: [number, number]
): [number, number] {
  if (configCenter) return configCenter;
  if (locations.length === 0) return MAP_DEFAULTS.CENTER;

  const lats = locations.map((l) => l.lat);
  const lngs = locations.map((l) => l.lng);

  const centerLat = (Math.min(...lats) + Math.max(...lats)) / 2;
  const centerLng = (Math.min(...lngs) + Math.max(...lngs)) / 2;

  return [centerLat, centerLng];
}

export function calculateCircleRadius(dataValue: number): number {
  const radius = Math.sqrt(dataValue) / MAP_DEFAULTS.CIRCLE_SCALE_FACTOR;
  return Math.min(Math.max(MAP_DEFAULTS.CIRCLE_MIN_RADIUS, radius), MAP_DEFAULTS.CIRCLE_MAX_RADIUS);
}

export function getCircleColor(dataLayer: string): string {
  switch (dataLayer) {
    case 'stock':
      return '#3b82f6';
    case 'releases':
      return '#10b981';
    case 'requests':
      return '#8b5cf6';
    default:
      return '#3b82f6';
  }
}
